import { recordEvent } from '@shared/utils/logger';

const EVENT_TYPE = 'CreateWeddingFlow';

type FlowAction =
  | 'AccountCreated'
  | 'AccountCreateFailed'
  | 'SignInCompleted'
  | 'SignInFailed'
  | 'PasswordResetRequested'
  | 'PasswordResetFailed'
  | 'SocialInterceptCtaClicked'
  | 'ExistingWeddingDetected'
  | 'FormSubmitted'
  | 'EventCreated'
  | 'EventCreateFailed'
  | 'RedirectInitiated';

type FlowEventAttributes = Readonly<{
  action: FlowAction;
  errorMessage?: Maybe<string>;
  socialProvider?: Maybe<string>;
  venueProvided?: Maybe<boolean>;
  dateProvided?: Maybe<boolean>;
  lastNameProvided?: Maybe<boolean>;
  eventId?: Maybe<string>;
  website?: Maybe<string>;
  adminOrOwnerEventCount?: Maybe<number>;
  durationDays?: Maybe<number>;
}>;

export function recordCreateWeddingFlowEvent(attributes: FlowEventAttributes): void {
  recordEvent(EVENT_TYPE, attributes);
}
